import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';
import {NationalDrugFormularyDTO} from 'src/app/modules/pbm/models/NationalDrugFormularyDTO';


@Injectable({
  providedIn: 'root'
})
export class NationalDrugFormularyService {

  private url = environment.baseUrl + '/national-drug-formulary';

  constructor(private httpClient: HttpClient) {
  }

  getListOfNationalDrugFormularies(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<NationalDrugFormularyDTO>> {
    return this.httpClient.post<PagedResponseDTO<NationalDrugFormularyDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveNationalDrugFormulary(nationalDrugFormularyDTO: NationalDrugFormularyDTO): Observable<NationalDrugFormularyDTO> {
    return this.httpClient.post<NationalDrugFormularyDTO>(this.url, nationalDrugFormularyDTO);
  }

  deleteNationalDrugFormulary(nationalDrugFormularyId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + nationalDrugFormularyId);
  }

  getNationalDrugFormulary(nationalDrugFormularyId: number): Observable<NationalDrugFormularyDTO> {
    return this.httpClient.get<NationalDrugFormularyDTO>(this.url + '/' + nationalDrugFormularyId);
  }
}
